import _ from 'lodash';

interface VideoMeta {
  id: string;
  name?: string;
  description: string;
  host?: 'vimeo';
}

export const videos: VideoMeta[] = [
  {
    name: 'Page Attachments',
    id: '738308142',
    description: '',
  },
];

const videoByKey = _.keyBy(videos, 'id');

export const getVideoMeta = (id: string) => videoByKey[id];
